// extracted by mini-css-extract-plugin
module.exports = {"instagram-wrapper":"Instagram_instagram-wrapper__jVJrS"};